import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ConsultationRequestService } from '@services/consultation-request.service';
import { ConsultationStorageService } from '@services/consultation-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ConsultationUpsellGuard implements CanActivate {
  private router = inject(Router);
  private consultationStorageService = inject(ConsultationStorageService);
  private consultationRequestService = inject(ConsultationRequestService);

  public canActivate(): boolean | UrlTree {
    if (!this.consultationStorageService.upsell.length) {
      return true;
    }

    const route = this.getQuestionnaireFirstNavigationUrl();
    const queryParams = {
      order_id: this.consultationStorageService.transactionId,
      hash: this.consultationStorageService.hash,
    };

    this.consultationRequestService.clearLastConsultationRequestData();

    return this.router.createUrlTree([route], { queryParams });
  }

  /**
   * Gets the first navigation URL from the questionnaire structure.
   *
   * @returns {string} the first navigation URL from the questionnaire structure
   */
  private getQuestionnaireFirstNavigationUrl(): string {
    return this.consultationStorageService.getQuestionnaireStructure(this.consultationStorageService.treatmentType)
      .navigationUrls[0];
  }
}
